import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { UserService } from '../User/user.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private readonly userSubject = new BehaviorSubject<any | null>(null);
  readonly user$ = this.userSubject.asObservable();

  constructor(private userService: UserService) {}

  get currentUser(): any | null {
    return this.userSubject.value;
  }

  setUser(user: any | null): void {
    this.userSubject.next(user ?? null);
  }

  loadUser(): Observable<any | null> {
    return this.userService.getMe().pipe(
      map((data) => data?.value ?? null),
      tap((user) => this.setUser(user))
    );
  }

  updateUser(): void {
    this.loadUser()
      .pipe(
        catchError(() => {
          this.setUser(null);
          return of(null);
        })
      )
      .subscribe();
  }
}
